import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { HomesBrowse } from '../../models/homes/homes-browse';
import { HomesService } from '../../services/homes.service';
import { RoomSearch } from '../../models/search/room-search';
import { RoomSearchProfile } from '../../models/homes/room-search-profile';
import { WidgetRoom } from '../../models/property/widget-room';
import { WidgetRoomOverview } from 'src/app/models/property/widget-room-overview';

@Injectable()
export class WidgetRoomsResolver implements Resolve<WidgetRoomOverview> {

    constructor(private homesService: HomesService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<WidgetRoomOverview> {

        let organisationReference = route.paramMap.get('organisation');
        let majorAreaReference = "";

        let availableOnly = false;
        let page = 1;
        let securityToken = "";

        let roomSearchProfile = new RoomSearchProfile();
        roomSearchProfile.roomSearch = new RoomSearch();

        if (route.queryParams['page']) {
            page = route.queryParams['page'];
        }

        if (route.queryParams['sec']) {
            securityToken = route.queryParams['sec'];
        }


        if (route.queryParams['availableOnly']) {
            availableOnly = route.queryParams['availableOnly'];
        }

        if (route.queryParams['city']) {
            majorAreaReference = route.queryParams['city'];
        }


        return this.homesService.getWidgetRooms(organisationReference, majorAreaReference, availableOnly, securityToken, page);
    }
}
